class ThcMediaSlider extends HTMLElement {
  #swiper = null;
  connectedCallback() {
    const io = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        this.#init();
        io.disconnect();
      }
    });
    io.observe(this);
  }

  disconnectedCallback() {
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }
  #init() {
    this.#swiper?.destroy(true, true);
    const paginationEl = this.querySelector('.swiper-pagination');

    this.#swiper = new Swiper(this.querySelector('.swiper'), {
      slidesPerView: 1,
      spaceBetween: 1,
      touchRatio: 1,
      touchAngle: 45,
      pagination: {
        el: paginationEl,
      },

    });
  }
}
if (!customElements.get('thc-media-slider')) {
  customElements.define('thc-media-slider', ThcMediaSlider);
}
